/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Potassium List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PotassiumListView';

export const mapStateToPropsPotassiumList = mapStateToProps;
export const mapDispatchToPropsPotassiumList = mapDispatchToProps;

export default connect(
  mapStateToPropsPotassiumList,
  mapDispatchToPropsPotassiumList
)(View);
